/** Тексты окна: Сезон: шкала и обмен кристаллов. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.season.title": "Season {n}",
  "win.season.left": "Ends in {d} d · your wave stays",
  "win.season.step": "Step {n} of {max}",
  "win.season.today": "Today {n}/{max}",
  "win.season.goal": "Season: {n} points to the next reward, {d} d left",
  "win.season.claim": "Claim",
  "win.season.pass": "Season pass",
  "win.season.terms":
    "One-time, for this season only. The pass opens the second track. It adds no points and does not change your league.",
  "win.season.shop": "Crystals",
  "win.season.speed": "x2 speed for {n} h",
  "win.season.speedOn": "x2 is on, add an hour",
  "win.season.bag": "Bag of {coins} coins",
  "win.season.hero": "Open {name} now",
  "win.season.ticket": "· saved",
  "win.season.useTicket": "Skip · {n}",
  "win.season.skipTickets": "Wait skips: {n}. Use them after the base falls.",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.season.title": "Сезон {n}",
  "win.season.left": "До конца {d} дн. · волна останется",
  "win.season.step": "Шаг {n} из {max}",
  "win.season.today": "Сегодня {n}/{max}",
  "win.season.goal": "Сезон: {n} очк. до награды, осталось {d} дн.",
  "win.season.claim": "Забрать",
  "win.season.pass": "Пропуск сезона",
  "win.season.terms":
    "Разовая покупка только на этот сезон. Пропуск открывает вторую дорожку. Очков не даёт и лигу не меняет.",
  "win.season.shop": "Кристаллы",
  "win.season.speed": "Скорость x2 на {n} ч",
  "win.season.speedOn": "x2 включена, добавить час",
  "win.season.bag": "Мешок: {coins} монет",
  "win.season.hero": "Открыть героя {name}",
  "win.season.ticket": "· из запаса",
  "win.season.useTicket": "Снятие · {n}",
  "win.season.skipTickets": "Снятий таймера: {n}. Пригодятся после падения штаба.",
};

const uk: Record<Key, string> = {
  "win.season.title": "Сезон {n}",
  "win.season.left": "До кінця {d} дн. · хвиля залишиться",
  "win.season.step": "Крок {n} із {max}",
  "win.season.today": "Сьогодні {n}/{max}",
  "win.season.goal": "Сезон: {n} оч. до нагороди, лишилось {d} дн.",
  "win.season.claim": "Забрати",
  "win.season.pass": "Пропуск сезону",
  "win.season.terms":
    "Разова покупка лише на цей сезон. Пропуск відкриває другу доріжку. Очок не дає і лігу не змінює.",
  "win.season.shop": "Кристали",
  "win.season.speed": "Швидкість x2 на {n} год",
  "win.season.speedOn": "x2 увімкнено, додати годину",
  "win.season.bag": "Мішок: {coins} монет",
  "win.season.hero": "Відкрити героя {name}",
  "win.season.ticket": "· із запасу",
  "win.season.useTicket": "Зняття · {n}",
  "win.season.skipTickets": "Знять таймера: {n}. Знадобляться після падіння штабу.",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
